import { useNotification } from 'lib/context/notification.context'
import { useCallback, useState } from 'react'
import { downloadSummaryReportUser } from 'services/common/reports/getProcessReport/get-process-reports-service'

interface GetReportsProcessFilters {
  processId: number
  useBetesa: boolean
  useCompetence: boolean
  use360?: boolean
  processName: string
  isForAllProcess?: boolean
  initDate?: string
  endDate?: string
  processIds?: number[]
  suppressWarning?: boolean
}

const useReportDownloaderByExcel = () => {
  const [loading, setLoading] = useState(false)
  const { getWarning } = useNotification()

  const fetchGetReportsByExcel = useCallback(
    async (data: GetReportsProcessFilters) => {
      const {
        processId,
        useBetesa,
        useCompetence,
        use360,
        processName,
        isForAllProcess,
        initDate,
        endDate,
        processIds,
        suppressWarning,
      } = data

      setLoading(true)

      try {
        const downloadReport = await downloadSummaryReportUser({
          processId,
          useBetesa,
          useCompetences: useCompetence,
          use360,
          isForAllProcess,
          initDate,
          endDate,
          processIds,
        })

        if (downloadReport instanceof ArrayBuffer) {
          const fileName = (() => {
            if (isForAllProcess && processIds?.length === 0 && !initDate) {
              return 'Resumen_General.xlsx'
            }

            if (isForAllProcess && initDate) {
              return `Resumen_desde-${initDate.replace(/\//g, '-')}-hasta-${endDate?.replace(/\//g, '-')}.xlsx`
            }

            if (isForAllProcess && processIds && processIds.length > 0) {
              return `Resumen_de_${processIds.length}_procesos.xlsx`
            }

            return `Resumen_${processName}.xlsx`
          })()

          const blob = new Blob([downloadReport], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
          const url = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          URL.revokeObjectURL(url)

          return downloadReport
        }

        if ((downloadReport as { status?: string })?.status === 'error') {
          const status = (downloadReport as { error?: { response?: { status?: number } } }).error?.response?.status
          if (status === 404) {
            if (!suppressWarning) getWarning('No hay registros para descargar')
            return { status: 'empty' }
          }
          if (!suppressWarning) getWarning('No se pudo generar el resumen')
        }

        return downloadReport
      } catch (error) {
        console.error('Error al obtener los informes: ', error)
        return { status: 'error', error }
      } finally {
        setLoading(false)
      }
    },
    [getWarning]
  )

  return { fetchGetReportsByExcel, loading }
}

export default useReportDownloaderByExcel
